module.exports = __webpack_public_path__ + "static/media/banner.0f0e83f1.jpg";